import React, { createContext, useState } from 'react';

export const LoyaltyProgramContext = createContext();

export const LoyaltyProgramProvider = ({ children }) => {
  const [validFromLtFilter, setValidFromLtFilter] = useState();
  const [validFromGtFilter, setValidFromGtFilter] = useState();
  const [validToLtFilter, setValidToLtFilter] = useState();
  const [validToGtFilter, setValidToGtFilter] = useState();
  const [nameFilter, setNameFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [sortOrder, setSortOrder] = useState('asc');
  const [filterBody, setFilterBody] = useState();

  return (
    <LoyaltyProgramContext.Provider
      value={{
        validFromLtFilter,
        setValidFromLtFilter,
        validFromGtFilter,
        setValidFromGtFilter,
        validToLtFilter,
        setValidToLtFilter,
        validToGtFilter,
        setValidToGtFilter,
        nameFilter,
        setNameFilter,
        statusFilter,
        setStatusFilter,
        sortOrder,
        setSortOrder,
        filterBody,
        setFilterBody,
      }}
    >
      {children}
    </LoyaltyProgramContext.Provider>
  );
};
